module.exports = "/_next/static/images/safariMaskIcon.external-de576c6cd9a18138de7a6ccc184c7ffe.svg";